import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import {
  Select,
  FormControl,
  MenuItem,
  OutlinedInput
} from '@material-ui/core';

export const PROBLEM_FILTER_OPTIONS = {
  BENCH: 'bench',
  OVER_ALLOCATION: 'overAllocation'
};

const useFormStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(0, 0, 0, 2)
  }
}));

const useSelectStyles = makeStyles(theme => ({
  root: {
    margin: 0
  },
  select: {
    fontSize: theme.typography.body2.fontSize,
    minHeight: `${theme.spacing(2)}px`,
    lineHeight: `${theme.spacing(2)}px`,
    padding: theme.spacing(1, 3, 1, 1.5),
    color: theme.palette.text.secondary
  }
}));

const outlinedInput = <OutlinedInput labelWidth={0} />;

const ProblemFilterDropdown = ({ value, onChange }) => {
  const selectClasses = useSelectStyles();
  const formClasses = useFormStyles();
  const { formatMessage } = useIntl();

  const handleOnChange = useCallback(
    event => {
      if (event.target.value && onChange) {
        onChange(event.target.value);
      }
    },
    [onChange]
  );

  const menuProps = useMemo(
    () => ({
      MenuListProps: {
        dense: true,
        'aria-label': formatMessage({
          id:
            'resourceManagementDashboard.benchOverAllocationTracker.problemFilterLabel'
        })
      }
    }),
    [formatMessage]
  );

  return (
    <FormControl className={formClasses.formControl}>
      <Select
        value={value}
        input={outlinedInput}
        onChange={handleOnChange}
        classes={selectClasses}
        MenuProps={menuProps}
        data-qe-id="problem-filter-dropdown"
      >
        <MenuItem value={PROBLEM_FILTER_OPTIONS.BENCH}>
          <FormattedMessage id="resourceManagementDashboard.benchOverAllocationTracker.problemFilterBenchOption" />
        </MenuItem>
        <MenuItem value={PROBLEM_FILTER_OPTIONS.OVER_ALLOCATION}>
          <FormattedMessage id="resourceManagementDashboard.benchOverAllocationTracker.problemFilterOverAllocationOption" />
        </MenuItem>
      </Select>
    </FormControl>
  );
};

ProblemFilterDropdown.propTypes = {
  value: PropTypes.oneOf(Object.values(PROBLEM_FILTER_OPTIONS)),
  onChange: PropTypes.func.isRequired
};

export default ProblemFilterDropdown;
